import { render, staticRenderFns } from "./staffLogin.vue?vue&type=template&id=2d239d2d&scoped=true&"
import script from "./staffLogin.vue?vue&type=script&lang=js&"
export * from "./staffLogin.vue?vue&type=script&lang=js&"
import style0 from "./staffLogin.vue?vue&type=style&index=0&id=2d239d2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d239d2d",
  null
  
)

export default component.exports